import { put } from 'redux-saga/effects'
import importer from 'common/importer'
const UserActions = importer('Stores/Users/Actions')
const { loginFlow } = importer('APIs/auth', null)
const { loginWithToken } = loginFlow

export default function * main ({refresh_token}) {
  try {
    yield put(UserActions.loginWithTokenLoading())
    const res = yield loginWithToken({refresh_token})
    yield put(UserActions.loginWithTokenSuccess(res.data))
  } catch (error) {
    yield put(UserActions.loginWithTokenFailure(error))
  }
}
